module.exports = __webpack_public_path__ + "assets/media/search.f539b64c.svg";